/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import GoldenInput from "../../atoms/GoldenInput";
import PillButton, { VARIANTS } from "../../atoms/PillButton";
import iconBirthdaysImg from "../../../assets/images/icon-birthdays.png";
import boldRightArrow from "../../../assets/images/arrow-bold.png";
import donationDesktop from "../../../assets/images/donation-desktop.png";
import donationMobile from "../../../assets/images/donation-mobile.png";
import { APPLICATION_ROUTES, COOKIES } from "../../../constants";
import { StoreContext } from "../../../contexts";
import Cookies from "../../../utilities/cookies";
import classes from "./DonateModal.module.scss";

const FREQUENCIES = [
  { id: "one_time", label: "One Time",  type: "donation",         interval: null },
  { id: "monthly",  label: "Monthly",   type: "donation_monthly", interval: 1 },
  { id: "yearly",   label: "Yearly",    type: "donation_yearly",  interval: 12 },
];

const computeFee = (amount) => {
  const n = parseFloat(amount);
  if (!n || n <= 0) return 0;
  return parseFloat((n * 0.029 + 0.3).toFixed(2));
};

const DonateContent = ({ onSubmit }) => {
  const history = useHistory();
  const { cart, authorization } = useContext(StoreContext);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const isLoggedIn = authorization.isAuthenticated;

  const [amount, setAmount]               = useState("");
  const [frequency, setFrequency]         = useState("one_time");
  const [coverFees, setCoverFees]         = useState(false);
  const [firstName, setFirstName]         = useState("");
  const [lastName, setLastName]           = useState("");
  const [email, setEmail]                 = useState("");
  const [createAccount, setCreateAccount] = useState(false);
  const [password, setPassword]           = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading]         = useState(false);
  const [anonymous, setAnonymous]         = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      setEmail(authorization.user.email || "");
      setFirstName(authorization.user.first_name || "");
      setLastName(authorization.user.last_name || "");
    }
  }, [isLoggedIn]);

  const parsedAmount = parseFloat(amount);
  const hasAmount    = parsedAmount > 0;
  const fee          = computeFee(amount);
  const totalAmount  = coverFees ? parsedAmount + fee : parsedAmount;

  const personalValid = isLoggedIn || (
    firstName.trim() !== "" &&
    lastName.trim()  !== "" &&
    email.trim()     !== "" &&
    (!createAccount || (
      password.trim() !== "" &&
      confirmPassword.trim() !== "" &&
      password === confirmPassword
    ))
  );
  const canSubmit = hasAmount && personalValid && !isLoading;

  const selectedFreq = FREQUENCIES.find((f) => f.id === frequency);

  const navigateToCheckout = () => {
    if (onSubmit) onSubmit();
    if (selectedFreq.type === "donation_monthly") {
      history.push(`${APPLICATION_ROUTES.CHECKOUT}?from=donation&type=donation_monthly`);
    } else if (selectedFreq.type === "donation_yearly") {
      history.push(`${APPLICATION_ROUTES.CHECKOUT}?from=donation&type=donation_yearly`);
    } else {
      history.push(`${APPLICATION_ROUTES.CHECKOUT}?from=donation`);
    }
  };

  const handleNext = async () => {
    if (!hasAmount) return;

    let recaptchaToken = null;
    if (executeRecaptcha) {
      try { recaptchaToken = await executeRecaptcha("donation"); } catch (e) { console.error("reCAPTCHA error:", e); }
    }

    const data = {
      client: {
        email:      email,
        first_name: firstName || undefined,
        last_name:  lastName  || undefined,
        password:   createAccount && password ? password : undefined,
      },
      details: {
        amount:     totalAmount,
        fee_include: coverFees ? fee : 0,
        email:      email,
        first_name: firstName || undefined,
        last_name:  lastName  || undefined,
        password:   createAccount && password ? password : undefined,
        cover_fees: coverFees,
      },
      type: selectedFreq.type,
    };

    if (selectedFreq.interval !== null) {
      data.details.interval = selectedFreq.interval;
    }

    if (!data.details.first_name) {
      delete data.client.first_name;
      delete data.details.first_name;
    }

    setIsLoading(true);
    cart.add({ data, recaptchaToken, onSuccess: navigateToCheckout });
  };

  const handleAnonymous = (checked) => {
    setAnonymous(checked);
    Cookies.set({ name: COOKIES.ANONYMOUS_PAYMENT, value: checked ? "true" : "" });
  };

  const handleBirthday = () => {
    if (onSubmit) onSubmit();
    history.push(APPLICATION_ROUTES.BIRTHDAY_PACKAGES_PAGE);
  };

  return (
    <div className={classes.content}>
      <p className={classes.subtitle}>
        Your contribution is more than a donation; it is{" "}
        <strong>hiskashrus in action today</strong>.
      </p>

      {/* Split amount + frequency box */}
      <div className={classes.amountBox}>
        {/* Left — orange background */}
        <div className={classes.amountLeft}>
          <input
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className={classes.amountInput}
          />
          <label className={classes.feeLabel}>
            <input
              type="checkbox"
              checked={coverFees}
              onChange={(e) => setCoverFees(e.target.checked)}
              className={classes.feeCheckbox}
            />
            <span>Add ${fee.toFixed(2)} to help cover the fees.</span>
          </label>
          <img src={donationDesktop} alt="" className={classes.donationArrowDesktop} />
          <img src={donationMobile}  alt="" className={classes.donationArrowMobile}  />
        </div>

        {/* Right — cream background */}
        <div className={classes.amountRight}>
          <div className={classes.freqTabs}>
            {FREQUENCIES.map((f) => (
              <PillButton
                key={f.id}
                variant={frequency === f.id ? VARIANTS.YELLOW : VARIANTS.GOLDEN_OUTLINE}
                onClick={() => setFrequency(f.id)}
                style={{
                  minWidth: "unset",
                  fontSize: "13px",
                  padding: "8px 22px",
                  ...(frequency === f.id ? { color: "#fff" } : {}),
                }}
              >
                {f.label}
              </PillButton>
            ))}
          </div>
          <p className={classes.cancelNote}>*You may cancel or change at any time.</p>
        </div>
      </div>

      {/* Birthday CTA */}
      <button className={classes.birthdayBtn} onClick={handleBirthday}>
        <span className={classes.birthdayIconWrap}>
          <img src={iconBirthdaysImg} alt="Birthday" className={classes.birthdayIcon} />
        </span>
        <span className={classes.birthdayText}>Celebrate your Birthday with us</span>
        <span className={classes.birthdayArrow}>
          <img src={boldRightArrow} alt="arrow" className={classes.rightArrow} />
        </span>
      </button>

      <div className={classes.divider} />

      {isLoggedIn ? (
        <p className={classes.loggedInNote}>
          Donating as <strong>{authorization.user.first_name} {authorization.user.last_name}</strong>
        </p>
      ) : (
        <>
          {/* Personal info */}
          <div className={classes.inputRow}>
            <GoldenInput
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <GoldenInput
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <GoldenInput
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />
          </div>

          {/* Create account */}
          <label className={classes.createAccount}>
            <input
              type="checkbox"
              checked={createAccount}
              onChange={(e) => setCreateAccount(e.target.checked)}
              className={classes.createCheckbox}
            />
            <span className={classes.createAccountText}>Create account?</span>
          </label>

          {/* Password + Confirm — shown when createAccount is checked */}
          {createAccount && (
            <div className={classes.passwordRow}>
              <GoldenInput
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />
              <GoldenInput
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                type="password"
              />
            </div>
          )}
        </>
      )}

      {/* Anonymous */}
      <label className={classes.createAccount}>
        <input
          type="checkbox"
          checked={anonymous}
          onChange={(e) => handleAnonymous(e.target.checked)}
          className={classes.createCheckbox}
        />
        <span className={classes.createAccountText}>I want to donate anonymously</span>
      </label>

      {/* Submit */}
      <div className={classes.submitWrap}>
        <PillButton
          variant={VARIANTS.GOLDEN}
          onClick={handleNext}
          disabled={!canSubmit}
          style={{
            minWidth: "160px",
            fontSize: "16px",
            padding: "12px 32px",
            justifyContent: "center",
            opacity: canSubmit ? 1 : 0.5,
            cursor: canSubmit ? "pointer" : "not-allowed",
          }}
        >
          {isLoading ? "Processing..." : "Next"}
        </PillButton>
      </div>

      {/* Contact info */}
      <div className={classes.contactInfo}>
        <p>
          Zelle Donations, can be sent to:{" "}
          <a href="mailto:zelle@maor.org" className={classes.link}>zelle@maor.org</a>
        </p>
        <p>
          For the more options and information, please contact our office:{" "}
          <a href="mailto:office@maor.org" className={classes.link}>office@maor.org</a>
          {" "}|{" "}
          <a href="tel:7186878900" className={classes.link}>718-687-8900</a>
        </p>
      </div>
    </div>
  );
};

export default DonateContent;
